import { Track } from "../../models/interfaces/track.interface";

const COVER_1 = 'assets/mocks/course-1-imageUrl.png';
const COVER_2 = 'assets/mocks/course-2-imageUrl.png';
const COVER_3 = 'assets/mocks/course-3-imageUrl.png';
const COURSE_1 = 'course-uuid-1';
const COURSE_2 = 'course-uuid-2';
const COURSE_3 = 'course-uuid-3';
const COURSE_4 = 'course-uuid-4';
const COURSE_5 = 'course-uuid-5';
const COURSE_6 = 'course-uuid-6';
const COURSE_7 = 'course-uuid-7';
const COURSE_8 = 'course-uuid-8';
const COURSE_9 = 'course-uuid-9';
const COURSE_10 = 'course-uuid-10';
const COURSE_11 = 'course-uuid-11';
const COURSE_12 = 'course-uuid-12';
const COURSE_PO = 'course-uuid-po';

export const tracksMock: Track[] = [
  { 
    id: '1', 
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'Frontend',
    description: 'Trilha focada em interfaces modernas, componentes reutilizaveis e experiencia do usuario.',
    coverImageUrl: COVER_1,
    coursesIds: [COURSE_1, COURSE_2, COURSE_3]
  },
  { 
    id: '2', 
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'Backend',
    description: 'Trilha voltada para APIs, modelagem de dados, seguranca e escalabilidade de servicos.',
    coverImageUrl: COVER_3,
    coursesIds: [COURSE_4, COURSE_5, COURSE_6]
  },
  { 
    id: '3', 
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'DevOps',
    description: 'Trilha para automacao de deploy, integracao continua, observabilidade e operacao em producao.',
    coverImageUrl: COVER_3,
    coursesIds: [COURSE_7, COURSE_8, COURSE_9]
  },
  {
    id: '4',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'Cloud',
    description: 'Trilha sobre fundamentos de nuvem, arquitetura distribuida e boas praticas de infraestrutura.',
    coverImageUrl: COVER_1,
    coursesIds: [COURSE_10],
  },
  {
    id: '5',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'Fullstack',
    description: 'Trilha para desenvolvimento ponta a ponta, integrando frontend, backend e entrega continua.',
    coverImageUrl: COVER_1,
    coursesIds: [COURSE_1, COURSE_4, COURSE_7, COURSE_10, COURSE_3, COURSE_PO],
  },
  {
    id: '6',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'Data Science',
    description: 'Trilha com analise de dados, estatistica aplicada e introducao a modelos de machine learning.',
    coverImageUrl: COVER_2,
    coursesIds: [COURSE_5, COURSE_8, COURSE_9],
  },
  {
    id: '7',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'Design',
    description: 'Trilha de design digital com foco em UX, UI, pesquisa com usuarios e prototipacao.',
    coverImageUrl: COVER_1,
    coursesIds: [COURSE_4, COURSE_7, COURSE_12],
  },
  {
    id: '8',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'Agile',
    description: 'Trilha para praticas ageis, colaboracao em times multidisciplinares e melhoria continua.',
    coverImageUrl: COVER_3,
    coursesIds: [COURSE_9, COURSE_11],
  },
  {
    id: '9',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'JavaScript',
    description: 'Trilha dedicada a linguagem JavaScript, ecossistema moderno e padroes de desenvolvimento.',
    coverImageUrl: COVER_2,
    coursesIds: [COURSE_8, COURSE_1],
  },
  {
    id: '10',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
    name: 'React',
    description: 'Trilha de React com componentes, estado, hooks e organizacao de aplicacoes escalaveis.',
    coverImageUrl: COVER_2,
    coursesIds: [COURSE_2],
  },
];